export const PARENT_PROFILE_FAVORITED_SITTER_EVENT = 'Parent Profile Favorited Sitter';
export const PARENT_PROFILE_UNFAVORITED_SITTER_EVENT = 'Parent Profile Unfavorited Sitter';
